import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m4 19 8-8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m12 19-8-8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Superscript";
const Superscript = memo(themed(Icon));
export {
  Superscript
};
//# sourceMappingURL=superscript.js.map
